import { getNestedProperty } from '@opallabs/lambda'
import {
  WorkflowCollection,
  Workflow,
  State,
  StateKeys,
} from '../../../../types'

type GetWorkflows = (state: State) => WorkflowCollection | undefined
type GetWorkflowByContext = (state: State, id: string) => Workflow | undefined

export const getWorkflows: GetWorkflows = (state) =>
  getNestedProperty<WorkflowCollection>(
    state,
    StateKeys.jsonApiEntities,
    StateKeys.workflow
  )

export const getWorkflowByContext: GetWorkflowByContext = (state, id) => {
  const workflows = getNestedProperty<WorkflowCollection>(
    state,
    'jsonApiEntities',
    'workflow'
  )

  if (workflows !== undefined) {
    return Object.values(workflows).find(
      (workflow: Workflow) =>
        getNestedProperty<string>(
          workflow,
          'relationships',
          'context',
          'id'
        ) === id
    )
  }

  return undefined
}
